<template>
    <v-container fluid>
        <v-toolbar flat color="white">
            <!--Employee FORM-->
            <template v-if="type === 'form'">
                <v-toolbar-title >{{ formTitle }}</v-toolbar-title>
            </template>
            <!--Employee VIEW TABLE-->
            <template v-if="type === 'view'">
                <v-toolbar-title>{{templateType}} Categories Table </v-toolbar-title>
                <v-spacer></v-spacer>
                <responsiveButton :setTo='"/orgWorkSpace/group-type/"+templateType+"/add/"'
                                  setColor="blue"
                                  setDefaultIcon="mdi-plus"
                                  setSmallIcon="mdi-plus-circle-outline"
                >
                    Add {{ templateType }} Category
                </responsiveButton>
            </template>
        </v-toolbar>
        <v-divider class="my-0 mx-6"></v-divider>
    </v-container>
</template>

<script>
    const responsiveButton = ()=> import( '@/components/common/mobile/Button');

    export default {
        name: "GroupTypeHeader",
        components:{responsiveButton},
        props:["hType", "tType", "tId", "tAction"],
        data(){
            return{
                type: this.hType,
                templateType: this.tType ,
                id: this.tId,
                action: this.tAction
            }
        },
        watch:{
            hType(value){
                this.type = value;
            },
            tType(value){
                this.templateType = value;
            },
            tId(value){
                this.id = value;
            },
            tAction(value){
                this.action = value;
            }
        },
        computed:{
            formTitle () {
                return this.id ? this.action.charAt(0).toUpperCase() + this.action.slice(1)+' '+this.templateType+' category' : 'New '+this.templateType+' category'
            },
        }
    }
</script>

<style scoped>

</style>